<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import type { DemoVideo } from '@/data/videoDemo'

defineProps<{ video: DemoVideo }>()
const imageFailed = ref(false)
</script>

<template>
  <RouterLink :to="`/video/${video.id}`" class="work-card">
    <div class="work-card-media">
      <img v-if="!imageFailed" :src="video.poster" :alt="`${video.title} 视频封面`" @error="imageFailed = true" />
      <strong v-else class="work-card-media-fallback" role="status">封面加载失败</strong>
      <span>查看视频</span>
    </div>
    <div class="work-card-body">
      <div class="card-meta"><span>{{ video.type }}</span><span>{{ video.duration }} · {{ video.ratio }}</span></div>
      <h3>{{ video.title }}</h3>
      <p>{{ video.context }}</p>
    </div>
  </RouterLink>
</template>
